import {DG_axios} from "../../../custom/axios";
import {DG_axiosNormal} from "../../../custom/axios/normal";

const baseURL = `/dogoo/employee-rest/v2.0/employees/`
const baseURLHasAccountFound = `/dogoo/common-api-rest/v2.0/employee-account-external-references-hrm-found-employee`;

export async function getEmployees(filter, page, pageSize, search, sort) {


    const response = await DG_axios.get(baseURL, {
            params: {
                filter,
                page,
                pageSize,
                search,
                sort
            }
        }
    )
    return response?.data || []
}

export async function getEmployeeById(id) {
    const response = await DG_axios.get(baseURL + `${id}`, null)
    return response?.data || []
}

export async function deleteEmployee(id) {
    const response = await DG_axios.delete(baseURL + `/${id}`)
    return response?.data || []
}

export async function updateEmployeeEducationApi(employeeId, data) {
    const response = await DG_axios.post(baseURL + employeeId + "/education", data)
    return response?.data || []
}

export async function getEmployeeEducationApi(employeeId) {
    const response = await DG_axios.get(baseURL + employeeId + "/education", {
        params: {
            filter: null,
            page: 1,
            pageSize: 10000,
            search: null,
            sort: null
        }
    })
    return response?.data || []
}
export async function autoCodeSuggest() {
    const response = await DG_axios.get(baseURL + "autocodesuggest");
    return response?.data?.code || "";
}

export async function getAllEmployeeReferencesHasAccountFound(filter, page, pageSize, search, sort) {

    const response = await DG_axiosNormal.get(baseURLHasAccountFound, {
            params: {
                filter,
                page,
                pageSize,
                search,
                sort
            }
        }
    )

    return response?.data || []
}


